import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import axios from "axios";
import {
  Row,
  Col,
  Card,
  Button,
  Space,
  message,
  Empty,
  Spin,
  Typography,
  Divider,
  Table,
  Modal,
  Input,
  InputNumber,
  Layout,
  Form,
} from "antd";
import {
  ACTION,
  CANCEL_REQUEST,
  DATE_TIME_FORMAT,
  FILE_TYPE,
} from "constants/index";
import emptyImg from "../../assets/img/empty.svg";
import AuthorizedFunction from "config/AuthorizedFunction";
import GeneralHelper from "helper/general.helper";
import NoteService from "services/note.service";
import { setUserWallet } from "redux/actions/auth.action";
const { Title } = Typography;

const initialValues = {
  amount: null,
};

const BidModal = ({ onUpdate, onClose, open = false, data }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    onClear();
  }, [open]);

  const onClear = () => {
    form.setFieldsValue(initialValues);
  };

  const handleCancel = () => {
    onClose(false);
  };

  const handleSubmit = (e) => {
    form
      .validateFields()
      .then((params) => {
        console.log(params);
        setIsLoading(true);
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        NoteService.bid({ ...params, item_id: data.id }, source).then(
          (request) => {
            message.info("Bid successfully submited", 5);
            dispatch(setUserWallet(request.user))
              .then(() => {
                onClear();
              })
              .catch((err) => {});
            setIsLoading(false);
            onClose(false);
            onUpdate({ status: 0 });
          },
          (error) => {
            if (error && error.response.data && error.response.data.errors) {
              message.error(error.response.data.errors.join(". "), 5);
            } else if (error && error.message !== CANCEL_REQUEST) {
              message.error("API got error, please contact us.", 5);
            }
            onClear();
            console.log(error);
            setIsLoading(false);
            return Promise.reject();
          }
        );
      })
      .catch((e) => {
        message.warning("Please check the form validation");
      });
  };

  return (
    data && (
      <Modal
        open={open}
        title={`Bid ${data.name}`}
        onOk={handleSubmit}
        onCancel={handleCancel}
        width={350}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={isLoading}
            onClick={handleSubmit}
          >
            Submit
          </Button>,
        ]}
      >
        <Divider />
        <Form layout="vertical" initialValues={initialValues} form={form}>
          <Space direction="vertical" size="very-small">
            <Form.Item
              name="bid_price"
              label="Bid Price"
              rules={[{ required: true, message: "Bid Price is required" }]}
            >
              <InputNumber
                style={{ width: 200 }}
                min="0.01"
                step="0.01"
                placeholder="Bid Price"
                allowClear
              />
            </Form.Item>
          </Space>
        </Form>
        <Divider />
      </Modal>
    )
  );
};
export default BidModal;
